<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ProcessType from "@/router/views/dts/dts-component/process-type";
import ActionType from "@/router/views/dts/dts-component/action-type";
import DUProcesses from "@/router/views/dts/dts-component/du-process";
import ProcessTypeModal from "@/router/views/dts/dts-modal/process-type-modal.vue";
import ReqStepModal from "@/router/views/dts/dts-modal/req-step-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
  page: {
    title: "Process Tracking Settings"
  },
  components: {
    Layout,
    PageHeader,
    ProcessType,
    ActionType,
    DUProcesses,
    ProcessTypeModal,
    ReqStepModal,
    PrintOptions
  },
  data() {
    return {
      title: "Process Tracking Settings",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Process Tracking Settings",
          active: true
        }
      ],
      modalTitle: "Create Process Type",
      processType: ""
    };
  },
  mounted() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(campus) {
      this.$refs.ProcessType.getData();
      this.$refs.ActionType.getData();
      this.$refs.DUProcess.getDus(campus.id);
    },
    addProcessType() {
      this.processType = "createProcessType";
      this.$refs.modalCreateProcessType.modalTitle = "Create Process Type";
      this.$refs.modalCreateProcessType.onReset();
      this.$bvModal.show("process-type-modal");
    },
    updateProcessType(data) {
      this.processType = "updateProcessType";
      this.$refs.modalCreateProcessType.modalTitle = "Update Process Type";
      this.$refs.modalCreateProcessType.setData(data);
      this.$bvModal.show("process-type-modal");
    },
    showPReqStep(data) {
      this.$refs.modalReqStep.modalTitle = `Requirements and Steps for ${data.processName}`;
      this.$refs.modalReqStep.setData(data);
      this.$bvModal.show("req-step-modal");
    },
    onSubmit($event) {
      if (
        this.processType === "createProcessType" ||
        this.processType === "updateProcessType"
      ) {
        this.$refs.ProcessType.onSubmit($event);
      }
    },
    printProcessType(item) {
      if (item.type) {
        this.$refs.printOpt.putOptions({
          apiUrl: "dts/api/Report/ProcessType/Owner",
          routeVariables: item.data
        });
      } else {
        this.$refs.printOpt.putOptions({
          apiUrl: "dts/api/Report/ProcessType",
          routeVariables: []
        });
      }
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <b-tabs
      pills
      vertical
      nav-class="p-0"
      nav-wrapper-class="col-sm-2"
      content-class="pt-0 px-2 text-muted"
    >
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Process Type</span>
        </template>
        <ProcessType
          ref="ProcessType"
          @addProcessType="addProcessType"
          @updateProcessType="updateProcessType"
          @show-req-step="showPReqStep"
          @print-process-type="printProcessType"
        >
        </ProcessType>
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Action Type</span>
        </template>
        <ActionType ref="ActionType"></ActionType>
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">Delivery Unit Processes</span>
        </template>
        <DUProcesses ref="DUProcess"></DUProcesses>
      </b-tab>
    </b-tabs>
    <ProcessTypeModal ref="modalCreateProcessType" @onSubmit="onSubmit" />
    <ReqStepModal ref="modalReqStep" />
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>
